import {Icon, IconQuestion} from '@flixbus/honeycomb-icons-react';
import {Tooltip} from '@flixbus/honeycomb-react';
import {formatSmartRounded} from '@/services/formatters';
import {ReadOnlyKpiInputConfig} from '@/Pages/ProductionCost/components/DataImportStepTwo/hooks/useReadOnlyKpiInputConfigBuilder';
import {ProductionCostBusScheduleKpi} from '@/Pages/ProductionCost/store/types';

export const getLineScheduleVehicleDriverShiftsKpisConfig: (
  vehicleEntryId: string
) => Partial<{
  [K in keyof ProductionCostBusScheduleKpi]: ReadOnlyKpiInputConfig;
}> = vehicleEntryId => ({
  avgWeeklyWorkingHours: {
    label: (
      <>
        Avg. driver working hours
        <Tooltip
          id={`entry-${vehicleEntryId}-avg-weekly-working-hours-tooltip`}
          position="top"
          content="Including standing time"
          openOnHover
        >
          <Icon
            size={4}
            InlineIcon={IconQuestion}
            style={{cursor: 'pointer', marginTop: '-3px', marginLeft: '4px'}}
            aria-label="Label Info Icon"
          />
        </Tooltip>
        :
      </>
    ),
    formatValue: kpi =>
      `${kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)} h/week`,
    id: `entry-${vehicleEntryId}-avg-weekly-working-hours`,
    order: 1
  },
  avgWeeklyScheduleHours: {
    label: 'Avg. schedule driving hours:',
    formatValue: kpi =>
      `${kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)} h/week`,
    id: `entry-${vehicleEntryId}-avg-weekly-schedule-hours`,
    order: 2
  },
  avgDriverFactor: {
    label: 'Avg. driver factor:',
    formatValue: kpi =>
      kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value),
    id: `entry-${vehicleEntryId}-avg-driver-factor`,
    order: 3
  },
  avgWeeklyOpDays: {
    label: 'Avg. operating days:',
    formatValue: kpi =>
      `${kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)} days/week`,
    id: `entry-${vehicleEntryId}-avg-weekly-op-days`,
    order: 4
  }
});
